
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { BsInfoCircleFill } from "react-icons/bs"
import { useSelector } from "react-redux";
import { Breadcrumb, Button, Checkbox, Collapse, Dropdown, Tooltip, notification } from "antd";
import TreeMapSkeleton from "../../../General/skeleton/TreeMapSkeleton";
import TreemapChart from "../../../Charts/TreemapChart";
import WhiteSpaceNewDisplayLegend from "../WhiteSpaceCharts/WhiteSpaceNewDisplayLegend";
import Container from "../../../General/Container/Container";
import { dynamicSort, formatNumber } from "../../../../utils/MainHelper";
import { fGetBehaviorMatchAndColor, fGetInterestLevel, fRenderShare, getAllKeywordsInFolder } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import TrackFeatureServices from "../../../../services/TrackFeature.services";
import ReportsServices from "../../../../services/Reports.services";
import InsightsServices from "../../../../services/Insights.services";
import CategoryDeepDiveContent from "../CategoryDeepDive/CategoryDeepDiveContent";
import ColumnFilter from "../../../General/ColumnFilter";
import { ArrowLeftOutlined, CaretRightOutlined, DownOutlined, HeartOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import DeepDiveCollapseHeader from "../../../General/DeepDiveCollapseHeader";
import { deepDiveColumns } from "../../../../config/TableColumns.config";
import { setBreadItems, setCachceTreeDetails, setChartData, setData, setLoadingText, setSubItemsDataPerGroupCachce, setSubItemsIsLoading } from "../../../../store/components/TreeMapReport.slice";

const columns = deepDiveColumns;
const { Panel } = Collapse
function CategoryDeepDiveTreeMap() {
    const dispatch = useDispatch()
    const infoRef = useRef()
    const mapRef = useRef()
    const { subItemsDataPerGroup, reportIsLoading, categoryDeepDiveData } = useSelector((state) => state.reports);
    const { subItemsDataPerGroupCache, cacheTreeDetails, chartData
        , data
        , loadingText
        , subItemsIsLoading
        , breadItems
    } = useSelector((state) => state.treemapreports);
    const [infoList, setInfoList] = useState([])
    const isLoading = subItemsIsLoading || reportIsLoading

    const hasLoadingInItem = categoryDeepDiveData.find((item) => item.loading);

    const onClickTile = (data) => {
        const tileData = data;
        if (tileData.tempChildren) {
            dispatch(setBreadItems({ item: tileData }))
        } else {
            console.log("No more deep dive.")
        }
    }

    const getBrandspaceSummaryText = (item) => {
        if (!item) return
        if (cacheTreeDetails[item.pathName]) {
            dispatch(setData([cacheTreeDetails[item.pathName]]))
            return
        }
        dispatch(setLoadingText(true))
        InsightsServices.getKeywordSuggestion([item.item]).then((resp) => {
            const selections = resp.data.reduce((acc, text) => {
                acc[text] = [text]
                return acc
            }, {})

            const notifObj = {
                message: `${item.item} Generating Report`,
                description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
                duration: null,
                placement: "topRight",
                closable: true,
                // closeIcon: (<div />),
                key: `${item.item}_subdeepdive-item`
            };
            const statusCallBack = (msg) => {
                notification.info({
                    ...notifObj,
                    description: <span style={{ color: "#52c41a" }}>{msg}</span>
                });
            };

            const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceRunDeepDive" })
            const { promise } = ReportsServices.getUsigDeepDive({ selections, masters: ReportsServices.getMasters(true) }, statusCallBack, commonParams);
            promise.then((response) => {
                if (response.length) {
                    const [itemToAdd] = response;
                    const objvalue = {
                        targetAudience: ReportsServices.getMastersTargetAudience(),
                        discoveredCategory: item.item,
                        children: (itemToAdd.children || itemToAdd.tempChildren)
                    }
                    dispatch(setCachceTreeDetails({
                        key: item.pathName,
                        value: objvalue
                    }));
                    dispatch(setData([objvalue]))
                }
                notification.destroy(`${item.item}_subdeepdive-item`);
                dispatch(setLoadingText(false))
            });
        })
    }

    const onload = () => {
        if (mapRef.current && infoRef.current) {
            try {
                const pRect = mapRef.current.getBoundingClientRect().toJSON()
                const { left: pLeft, top: pTop } = pRect
                let tempList = []
                const paths = Array.from(mapRef.current.querySelectorAll("svg g:nth-last-child(1) path"));
                paths.forEach((path, idx) => {
                    const rect = path.getBoundingClientRect().toJSON()
                    const { left, top, width, height } = rect
                    const currentItem = chartData[idx]
                    const { score, audienceIntersect } = currentItem;
                    const isSmallMapWidth = width < 168
                    const isSmallMapHeight = height < 59
                    let textFontSize = "14px"
                    let iconFontSize = "11px"
                    if (isSmallMapWidth) {
                        textFontSize = `${width * 0.075}px`
                        iconFontSize = `${width * 0.06}px`
                    }
                    if (isSmallMapHeight) {
                        const multiplier = width < 42 ? 0.055 : 0.155
                        textFontSize = `${height * multiplier}px`
                        iconFontSize = `${height * multiplier}px`
                    }
                    const displaySize = audienceIntersect
                    const itemTipStyle = {
                        display: "block",
                        // width: "100%",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        overflow: "hidden",
                        fontSize: "14px"
                    }
                    const itemStyle = {
                        display: "block",
                        // width: "100%",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        overflow: "hidden",
                        fontSize: textFontSize
                    }
                    const divElem = <Tooltip placement="top" title={<div>
                        <Container>
                            <label style={itemTipStyle}>{currentItem.item || currentItem.name}</label>
                        </Container>
                        <Container className="drow align-center gap-1"><Container className="drow gap-5p">
                            <HeartOutlined />
                            <label style={itemTipStyle}> {`${(formatNumber(score, 2))}%`}</label>
                        </Container>{displaySize ? <Container className="drow gap-5p">
                            <UsergroupAddOutlined />
                            <label style={itemTipStyle}>{formatNumber(displaySize)}</label>
                        </Container> : null}
                        </Container>

                    </div>}><div
                        style={{
                            display: "flex",
                            flexFlow: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "absolute",
                            left: (left - pLeft),
                            top: (top - pTop),
                            height,
                            width,
                            zIndex: 2,
                            cursor: "pointer",
                            color: "white",
                            fontSize: iconFontSize,
                            overflow: "hidden",
                            padding: "10px",
                            textAlign: "center"
                        }}
                        onClick={() => {
                            onClickTile(currentItem)
                        }}
                    >
                            <Container>
                                <label style={itemStyle}>{currentItem.item || currentItem.name}</label>
                            </Container>
                            <Container className="drow align-center gap-1"><Container className="drow gap-5p">
                                <HeartOutlined />
                                <label style={itemStyle}> {`${(formatNumber(score, 2))}%`}</label>
                            </Container>{displaySize ? <Container className="drow gap-5p">
                                <UsergroupAddOutlined />
                                <label style={itemStyle}>{formatNumber(displaySize)}</label>
                            </Container> : null}</Container>

                            {((!currentItem.tempChildren && !currentItem.tChildren) ? <BsInfoCircleFill
                                onClick={() => {
                                    getBrandspaceSummaryText(currentItem)
                                }}
                                style={{
                                    position: "absolute",
                                    right: "2px",
                                    top: "2px",
                                    color: "black",
                                    zIndex: 3,
                                    fill: "rgb(242 238 238)",
                                    fontSize: "15px",
                                    cursor: "pointer"
                                }} /> : null)
                            }
                        </div>
                    </Tooltip>
                    tempList.push(divElem);
                })
                setInfoList(tempList)
            } catch (error) {
                setInfoList([])
            }
        }
    }

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (breadItems.length > 1) {
                const currentBread = breadItems[breadItems.length - 1]
                if (currentBread.tempChildren[0].audienceIntersect !== undefined) {
                    dispatch(setData([]))
                    dispatch(setChartData(currentBread.tempChildren.map((item) => {
                        return {
                            ...item,
                            score: item.score * 100,
                            value: item.share || item.masterSize,
                            pathName: currentBread.pathName + "/" + item.item
                        }
                    }).sort(dynamicSort("-value", true))))
                } else {
                    const cacheKey = currentBread.group + "~~" + currentBread.item
                    if (subItemsDataPerGroupCache[cacheKey]) {
                        dispatch(setData([]))
                        dispatch(setChartData(subItemsDataPerGroupCache[cacheKey].children.map((item) => {
                            const newItem = {
                                ...item,
                                score: item.score * 100,
                                value: item.share,
                                tChildren: item.children,
                                pathName: currentBread.pathName + "/" + item.item
                            }
                            delete newItem.children
                            return newItem
                        }).sort(dynamicSort("-value", true))))
                    } else {
                        const lastBreadChildren = currentBread.tempChildren;
                        if (lastBreadChildren) {
                            const childObjectList = {};
                            const selections = {};
                            (lastBreadChildren).forEach((item) => {
                                const childName = item.name.toLocaleLowerCase();
                                const childList = item.children || item.tChildren || item.tempChildren;
                                if (childList && childList.length) {
                                    childObjectList[childName] = childList;
                                }
                                selections[childName] = childList ? getAllKeywordsInFolder(childList, []) : [childName];
                            });
                            const notifObj = {
                                message: `${currentBread.item} Generating Report`,
                                description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
                                duration: null,
                                placement: "topRight",
                                closable: true,
                                // closeIcon: (<div />),
                                key: `${currentBread.item}_subdeepdive-item`
                            };
                            notification.info(notifObj);
                            const statusCallBack = (msg) => {
                                notification.info({
                                    ...notifObj,
                                    description: <span style={{ color: "#52c41a" }}>{msg}</span>
                                });
                            };

                            const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceRunDeepDive" })

                            const parentPath = lastBreadChildren[0].parentPath.split("/").reduce((acc, keyPath) => {
                                acc.push(keyPath.split("~~")[1])
                                return acc
                            }, []).join("/")

                            const { promise } = ReportsServices.getUsigDeepDive({ selections, masters: ReportsServices.getMasters(true), category: { [parentPath]: selections } }, statusCallBack, commonParams);
                            dispatch(setSubItemsIsLoading(true));
                            promise.then((response) => {
                                if (response.length) {
                                    const [itemToAdd] = response;
                                    dispatch(setSubItemsDataPerGroupCachce({
                                        key: cacheKey,
                                        value: {
                                            discoveredCategory: currentBread.item,
                                            children: (itemToAdd.children || itemToAdd.tempChildren).map((res) => {
                                                const childName = res.item.toLocaleLowerCase();
                                                const newResObj = { ...res };
                                                if (childObjectList[childName]) newResObj.tempChildren = childObjectList[childName];
                                                return newResObj;
                                            })
                                        }
                                    }));
                                }
                                notification.destroy(`${currentBread.item}_subdeepdive-item`);
                                dispatch(setSubItemsIsLoading(false));
                            });
                        }
                    }
                }
            } else {
                dispatch(setData([]))
                dispatch(setChartData(categoryDeepDiveData.map((item) => {
                    const { score, share, audienceIntersect } = item.children.reduce((acc, child) => {
                        acc.score += child.score
                        acc.share += child.share
                        acc.audienceIntersect += child.audienceIntersect
                        return acc
                    }, {
                        score: 0, share: 0, audienceIntersect: 0
                    })

                    return {
                        name: item.discoveredCategory,
                        item: item.discoveredCategory,
                        score: (score / item.children.length) * 100,
                        audienceIntersect,
                        share,
                        tempChildren: item.children,
                        value: share || item?.children?.[0]?.masterSize,
                        masterSize: item?.children?.[0]?.masterSize || 0,
                        pathName: item.discoveredCategory
                    }
                }).sort(dynamicSort("-value", true))))
                onload()
            }
        }, 100)

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [categoryDeepDiveData, breadItems, subItemsDataPerGroupCache])

    const bodyRect = window.document.body.getBoundingClientRect()
    useEffect(() => {
        let timeout = null
        function updateSize() {
            setInfoList([])
            if (timeout) {
                clearTimeout(timeout)
            }
            timeout = setTimeout(() => {
                onload()
            }, 100)
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, [mapRef, infoRef, bodyRect.width, bodyRect.height, chartData]);

    const [listOfHiddenColumns, setlistOfHiddenColumns] = useState({});

    const { filteredColumns, filteredValues } = columns.reduce((acc, col) => {
        if (!col.type || col.type === "column") {
            acc.filteredColumns.push(col);
        } else {
            acc.filteredValues.push(col);
        }
        return acc;
    }, {
        filteredColumns: [],
        filteredValues: []
    });

    return (
        <Container className="report--legacytree">
            <Container className="report--legacytree--item">
                <Container style={{ height: "8mm" }}>
                    {breadItems.length > 1 ? <Breadcrumb>
                        {breadItems.map((obj, idx) => {
                            if (breadItems.length - 1 === idx) {
                                return <Breadcrumb.Item key={obj.name || obj.item}>
                                    <span className="c-bg-700 fw-500 fs-16">
                                        {obj.name || obj.item}
                                    </span>
                                </Breadcrumb.Item>
                            }
                            return <Breadcrumb.Item key={obj.name || obj.item}>
                                <Button
                                    disabled={isLoading}
                                    className="c-bg-400"
                                    style={{ padding: 0 }}
                                    type="link"
                                    onClick={() => {
                                        dispatch(setBreadItems({ mode: "back", idx }))
                                    }}
                                    icon={(!idx) ? <ArrowLeftOutlined /> : ""}
                                >
                                    {obj.name || obj.item}
                                </Button>
                            </Breadcrumb.Item>
                        })}
                    </Breadcrumb> : null}
                </Container>
                <Container className="drow justify-end align-end" style={{ height: "8mm" }}>
                    <Container className="drow align-end gap-5p">
                        <Container className="drow align-center gap-5p">
                            <HeartOutlined style={{ fontSize: "14px", color: "#2563EB" }} />
                            <span style={{
                                color: "#475569",
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "16px"
                            }}>Interest Level</span>
                        </Container>
                        <Container className="drow align-center gap-5p">
                            <UsergroupAddOutlined style={{ fontSize: "14px", color: "#2563EB" }} />
                            <span style={{
                                color: "#475569",
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "16px"
                            }}>Target Size</span>
                        </Container>
                        <span style={{
                            color: "#475569",
                            fontSize: "12px",
                            fontWeight: "400",
                            lineHeight: "16px"
                        }}>|</span>
                        <WhiteSpaceNewDisplayLegend prefixLabel="High Engagement" suffixLabel="Low Interest" />
                    </Container>
                </Container>
                <div style={{ height: "calc(100% - 20mm)", width: "100%" }}>
                    {(!isLoading && !hasLoadingInItem) ?
                        <>
                            <div ref={infoRef} style={{ position: "relative" }}>
                                {infoList.map((info) => info)}
                            </div>
                            <TreemapChart
                                ref={mapRef}
                                onload={onload}
                                data={chartData}
                                config={{
                                    renderer: "svg",
                                    rawFields: ["score", "tempChildren"],
                                    label: {
                                        formatter: (e) => ""
                                    },
                                    tooltip: {
                                        formatter: (e) => ""
                                    },
                                    color: ({ score }) => {
                                        if (score > 50) return "#458A46"
                                        if (score > 30 && score <= 49.99) return "#57AD57"
                                        if (score > 20 && score <= 29.99) return "#7DC97F"
                                        if (score > 15 && score <= 19.99) return "#88898B"
                                        if (score > 10 && score <= 14.99) return "#EF4444"
                                        if (score > 5 && score <= 9.99) return "#DC2626"
                                        return "#B91C1C"
                                    }
                                }}
                            />
                        </>
                        : <TreeMapSkeleton />}
                </div>
                <Container style={{ height: "8mm" }}>
                    <span style={{
                        // color: "#475569",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "16px",
                        color: "#64748B"
                    }}>*Size of each tile is proportionate to market size</span>
                </Container>
            </Container>

            {(data.length || loadingText) ? <Collapse
                activeKey={["details_item", "empty"]}
                className="report--categorydeepdive--collapse"
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            // onChange={(e) => {
            //     setactiveKeys([...e, "empty"]);
            // }}
            >
                {(data.length && !loadingText)
                    ? data.map((item) => {
                        const { showedColumns, showedValues } = listOfHiddenColumns[item.group]?.length
                            ? ({
                                showedColumns: filteredColumns.filter((col) => (!listOfHiddenColumns[item.group].includes(col.key))),
                                showedValues: filteredValues.filter((col) => (!listOfHiddenColumns[item.group].includes(col.key)))
                            })
                            : ({
                                showedColumns: filteredColumns,
                                showedValues: filteredValues
                            });
                        const discoveredTitle = subItemsDataPerGroup[item.group]
                            ? subItemsDataPerGroup[item.group].discoveredCategory
                            : item.discoveredCategory;

                        const subItemsData = subItemsDataPerGroup[item.group];

                        const summaryBehaviorMatch = {};
                        const toHideRowWithValue = showedValues.map((i) => i.key);
                        const filteredItem = { ...(subItemsData || item) }
                        filteredItem.group = item.group;
                        filteredItem.children = filteredItem.children.reduce((acc, i) => {
                            const newObj = {
                                ...i,
                                key: i.item,
                                ...fGetBehaviorMatchAndColor(i.score),
                                group: item.group
                            };

                            if (!summaryBehaviorMatch[newObj.behaviormatch]) {
                                summaryBehaviorMatch[newObj.behaviormatch] = {
                                    count: 1,
                                    behaviormatch: newObj.behaviormatch,
                                    color: newObj.color,
                                    bg: newObj.bg
                                };
                            } else {
                                summaryBehaviorMatch[newObj.behaviormatch].count += 1;
                            }

                            if (toHideRowWithValue.length) {
                                if (toHideRowWithValue.includes(newObj.behaviormatch)) {
                                    acc.push(newObj);
                                }
                            } else {
                                acc.push(newObj);
                            }
                            return acc;
                        }, []);
                        const share = fRenderShare(filteredItem.children);
                        const itemPercent = fGetInterestLevel(filteredItem.children);
                        const itemStatus = fGetBehaviorMatchAndColor(itemPercent / 100);
                        const objCssSum = {
                            color: itemStatus.color,
                            backgroundColor: itemStatus.bg,
                            padding: ".5mm 1mm",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "22px"
                        };

                        return (
                            <Panel
                                className={`report--categorydeepdive--collapse--item ${itemStatus.behaviormatch}`}
                                key={"details_item"}
                                collapsible={"disabled"}
                                showArrow={false}
                                header={(
                                    <div className="d-flex-col gap-1">
                                        <div className="d-flex align-items-center" style={{ width: "100%" }}>
                                            {!loadingText ? <DeepDiveCollapseHeader
                                                discoveredCategory={discoveredTitle}
                                                targetAudience={item.targetAudience}
                                                loading={loadingText}
                                            >
                                                <div className="d-flex gap-2 align-items-start" style={{ whiteSpace: "nowrap" }}>
                                                    {share && (
                                                        <div className="d-flex align-items-center gap-1" key="summary-size">
                                                            <span className="d-flex gap-1-2 align-items-center text-bgray-500 fw-400">
                                                                <UsergroupAddOutlined
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        marginRight: "1mm"
                                                                    }}
                                                                />
                                                                Size:
                                                            </span>
                                                            <span style={objCssSum}>{share}</span>
                                                        </div>
                                                    )}
                                                    {(!isNaN(itemPercent)) && (
                                                        <div className="d-flex align-items-start gap-1" key="summary-interest">
                                                            <span className="d-flex gap-1-2 align-items-center text-bgray-500 fw-400">
                                                                <HeartOutlined
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        marginRight: "1mm"
                                                                    }}
                                                                />
                                                                Interest level:
                                                            </span>
                                                            <div className="d-flex align-items-center gap-1 flex-wrap">
                                                                {Object.values(summaryBehaviorMatch).map((BMList) => (
                                                                    <span
                                                                        key={BMList.behaviormatch}
                                                                        style={{
                                                                            color: BMList.color,
                                                                            backgroundColor: BMList.bg,
                                                                            padding: ".5mm 1mm",
                                                                            fontWeight: "500",
                                                                            fontSize: "14px",
                                                                            lineHeight: "22px"
                                                                        }}
                                                                    >
                                                                        {`${BMList.behaviormatch} (${BMList.count})`}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                            </DeepDiveCollapseHeader> : ""}
                                        </div>
                                    </div>
                                )}
                            // extra={activeKeys.includes(item.key) ? (
                            //     <div className="d-flex gap-1">
                            //         <ColumnFilter
                            //             disabled={loadingText}
                            //             columns={columns}
                            //             group={item.group}
                            //             onChange={onChangeHiddenColumns}
                            //             hidden={listOfHiddenColumns[item.group]}
                            //         />
                            //     </div>
                            // ) : null}
                            >
                                <CategoryDeepDiveContent
                                    loading={loadingText}
                                    share={share}
                                    data={filteredItem}
                                    interestLevel={itemPercent}
                                    itemStatus={itemStatus}
                                    columns={showedColumns}
                                    filteredValues={toHideRowWithValue}
                                    dontDeepDive
                                    noCheckbox
                                />
                            </Panel>
                        );
                    })
                    : (
                        <Panel
                            className="report--categorydeepdive--collapse--item"
                            key="empty"
                            showArrow={false}
                            collapsible="disabled"
                            header={(
                                <div className="d-flex align-items-center" style={{ width: "100%" }}>
                                    <DeepDiveCollapseHeader
                                        discoveredCategory={loadingText ? "Loading..." : ""}
                                        targetAudience={loadingText ? "Loading..." : ""}
                                    />
                                </div>
                            )}
                        >
                            <CategoryDeepDiveContent loading={loadingText} />
                        </Panel>
                    )}
            </Collapse> : null}
        </Container>
    );
}

export default CategoryDeepDiveTreeMap;
